/* Waifu Wicks – add to cart without leaving the page.
   Progressive enhancement: forms with .ww-ajax-form still submit normally if this file fails.
   The popup shows the line price, the cart subtotal and free-shipping progress. Totals come from
   /cart.js; if that isn't reachable, the page-load cart total plus what was just added is used. */
(function () {
  var toast = document.getElementById('ww-toast');
  var live = document.getElementById('ww-live');
  var hideTimer = null;
  var lastFocus = null;
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var addUrl = (window.routes && window.routes.cart_add_url) || root + 'cart/add';

  function fmt(cents) {
    if (window.WWMoney) return window.WWMoney(cents / 100);
    return '$' + (cents / 100).toFixed(2);
  }
  function setCount(n) {
    document.querySelectorAll('[data-ww-cart-count]').forEach(function (el) { el.textContent = n; el.hidden = !(n > 0); });
    document.querySelectorAll('[data-ww-cart-link]').forEach(function (el) { el.setAttribute('aria-label', 'Cart, ' + n + (n === 1 ? ' item' : ' items')); });
  }
  function currentCount() {
    var el = document.querySelector('[data-ww-cart-count]');
    return el ? parseInt(el.textContent, 10) || 0 : 0;
  }

  function hideToast(quiet) {
    if (!toast || toast.hidden) return;
    var hadFocus = toast.contains(document.activeElement);
    toast.classList.remove('is-open');
    clearTimeout(hideTimer);
    setTimeout(function () { toast.hidden = true; }, 250);
    // Only move focus back when focus was inside the popup (never steal it on auto-close or outside click).
    if ((!quiet || hadFocus) && lastFocus && document.contains(lastFocus)) lastFocus.focus({ preventScroll: true });
  }

  function showTotals(total) {
    if (!toast || total == null) return;
    var sub = toast.querySelector('.ww-toast__subtotal');
    sub.querySelector('[data-ww-subtotal]').textContent = fmt(total);
    sub.hidden = false;
    var threshold = parseInt(toast.dataset.threshold, 10) || 0;
    var ship = toast.querySelector('.ww-toast__ship');
    if (!threshold) { ship.hidden = true; return; }
    var left = threshold - total;
    ship.querySelector('[data-ww-ship-msg]').textContent = left > 0
      ? 'You’re ' + fmt(left) + ' away from free US shipping'
      : 'You’ve unlocked free US shipping ✨';
    ship.querySelector('[data-ww-ship-bar]').style.width = Math.min(100, Math.round(total * 100 / threshold)) + '%';
    ship.classList.toggle('is-done', left <= 0);
    ship.hidden = false;
  }

  function showToast(opts) {
    if (!toast) return;
    var name = toast.querySelector('.ww-toast__name');
    var line = toast.querySelector('.ww-toast__line');
    var img = toast.querySelector('.ww-toast__img');
    var err = toast.querySelector('.ww-toast__error');
    var title = toast.querySelector('.ww-toast__title span');
    var item = toast.querySelector('.ww-toast__item');
    var actions = toast.querySelector('.ww-toast__actions');
    toast.querySelector('.ww-toast__subtotal').hidden = true;
    toast.querySelector('.ww-toast__ship').hidden = true;
    if (opts.error) {
      title.textContent = 'Couldn’t add that';
      err.textContent = opts.error; err.hidden = false; item.hidden = true;
    } else {
      title.textContent = 'Added to your cart ✨';
      err.hidden = true; item.hidden = false;
      name.textContent = (opts.qty > 1 ? opts.qty + ' × ' : '') + (opts.title || 'Item');
      if (opts.line != null) { line.textContent = fmt(opts.line); line.hidden = false; } else { line.hidden = true; }
      if (opts.image) { img.style.backgroundImage = 'url("' + opts.image + '")'; img.hidden = false; } else { img.hidden = true; }
    }
    actions.hidden = !!opts.error;
    toast.hidden = false;
    requestAnimationFrame(function () { toast.classList.add('is-open'); });
    if (live) live.textContent = opts.error ? opts.error : (opts.title || 'Item') + ' added to cart';
    shownAt = window.scrollY;
    armTimer(5000);
  }

  // Auto-close after ~5s; pauses while hovered or focused; closes on outside click, Esc or a long scroll.
  var shownAt = 0;
  function armTimer(ms) {
    clearTimeout(hideTimer);
    hideTimer = setTimeout(function () {
      if (toast.contains(document.activeElement) || toast.matches(':hover')) { armTimer(2500); return; }
      hideToast(true);
    }, ms);
  }
  if (toast) {
    toast.addEventListener('mouseenter', function () { clearTimeout(hideTimer); });
    toast.addEventListener('mouseleave', function () { if (!toast.hidden) armTimer(2500); });
    toast.addEventListener('focusin', function () { clearTimeout(hideTimer); });
    toast.addEventListener('focusout', function (e) { if (!toast.contains(e.relatedTarget) && !toast.hidden) armTimer(2500); });
    document.addEventListener('pointerdown', function (e) {
      if (toast.hidden || toast.contains(e.target)) return;
      if (e.target.closest('form.ww-ajax-form, [data-ww-atc]')) return; // adding again keeps it open
      hideToast(true);
    });
    window.addEventListener('scroll', function () {
      if (!toast.hidden && Math.abs(window.scrollY - shownAt) > 400) hideToast(true);
    }, { passive: true });
  }

  function refreshCart(addedQty, addedLine) {
    return fetch(root + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (c) {
        if (typeof c.item_count !== 'number') throw 0;
        setCount(c.item_count);
        toast.dataset.cartTotal = c.total_price;
        toast.dataset.cartCount = c.item_count;
        showTotals(c.total_price);
      })
      .catch(function () {
        // /cart.js unavailable: page-load cart + items added on this page.
        setCount(currentCount() + addedQty);
        if (addedLine == null) return;
        var total = (parseInt(toast.dataset.cartTotal, 10) || 0) + addedLine;
        toast.dataset.cartTotal = total;
        showTotals(total);
      });
  }

  function onSubmit(e) {
    var form = e.target.closest ? e.target.closest('form.ww-ajax-form') : null;
    if (!form || !window.fetch) return;
    e.preventDefault();
    var btn = form.querySelector('[type="submit"]');
    if (btn && (btn.disabled || btn.getAttribute('aria-disabled') === 'true')) return;
    var fd = new FormData(form);
    var qty = parseInt(fd.get('quantity'), 10) || 1;
    var info = (btn && btn.dataset) || {};
    var title = form.dataset.wwTitle || info.wwTitle;
    var image = form.dataset.wwImage || info.wwImage;
    var unit = parseInt(form.dataset.wwUnitPrice || info.wwUnitPrice, 10);
    if (form.dataset.wwVariant) title = title + ' (' + form.dataset.wwVariant + ')';
    lastFocus = btn || document.activeElement;
    if (btn) { btn.classList.add('is-loading'); btn.setAttribute('aria-busy', 'true'); }

    fetch(addUrl + '.js', { method: 'POST', body: fd, headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' } })
      .then(function (r) {
        return r.text().then(function (txt) {
          var data = null;
          try { data = JSON.parse(txt); } catch (err) { /* non-JSON response */ }
          if (!r.ok) throw new Error((data && (data.description || data.message)) || 'Please try again.');
          return data;
        });
      })
      .then(function (data) {
        var line = data && typeof data.final_line_price === 'number' ? data.final_line_price : (isNaN(unit) ? null : unit * qty);
        showToast({ title: title, image: image, qty: qty, line: line });
        return refreshCart(qty, line);
      })
      .catch(function (err) { showToast({ error: err.message || 'Please try again.' }); })
      .finally(function () { if (btn) { btn.classList.remove('is-loading'); btn.removeAttribute('aria-busy'); } });
  }

  document.addEventListener('submit', onSubmit);
  document.addEventListener('click', function (e) { if (e.target.closest('[data-ww-toast-close]')) hideToast(); });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && toast && !toast.hidden) hideToast(); });
  window.WWCart = { setCount: setCount, show: showToast };
})();
